import type { IMaskFunction } from 'interfaces/IMask';

const singledigit: IMaskFunction = {
  apply: (value: string) => {
    if (!value) return value;

    return value.replace(/\D/g, '');
  },
  clean: (value: string) => value.substr(0, 1)
};

export default singledigit;
